import { httpClient } from '../http';
import { environmentBuilder } from '../../core/helpers/environmentBuilder';
import { CRASH_PATH_NAME, detectSocketPath } from '../../core/constants/socketPathName';
import { getHistoryUrl } from '../../games/limbo/limboCore/helpers';

class BetHistoryService {
  constructor({ url }) {
    this.url = url;
  }

  getBetHistory(params) {
    return httpClient.get(getHistoryUrl(this.url), { params });
  }
}

const gameName = detectSocketPath(
  window.location.pathname === '/' ? CRASH_PATH_NAME : window.location.pathname
);

const { httpUrl } = environmentBuilder(gameName);

export const betHistoryService = new BetHistoryService({ url: httpUrl });
